import { Stack, StackProps, SxProps } from '@mui/material';
import { ReactNode } from 'react';

import { SizingMultiplier } from '../index';

type HorizontalCarouselProps = {
  children: ReactNode;
  spacing?: StackProps['spacing'];
  sx?: SxProps;
};

const DEFAULT_SPACING = 2;

export const HorizontalCarousel = ({ spacing = DEFAULT_SPACING, sx, children }: HorizontalCarouselProps) => {
  return (
    <Stack
      direction="row"
      spacing={spacing}
      sx={{
        overflowX: 'auto',
        '::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar in Webkit browsers
        scrollbarWidth: 'none', // Hide scrollbar in Firefox
        msOverflowStyle: 'none', // Hide scrollbar in IE/Edge

        // needed for scrolling effect on mobile
        mr: (theme) => `-${theme.spacing(SizingMultiplier.sm)} !important`,
        pr: SizingMultiplier.sm,
        ml: (theme) => `-${theme.spacing(SizingMultiplier.sm)} !important`,
        pl: SizingMultiplier.sm,
        ...sx,
      }}>
      {children}
    </Stack>
  );
};
